// SilverZakatCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SilverZakatTable from "./SilverZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Silver_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Zakat Perak 2026 - Kalkulator Nisab Zakat Perak";
const DESCRIPTION =
  "Kalkulator Zakat Perak adalah alat yang digunakan untuk menghitung jumlah zakat perak yang wajib dikeluarkan sesuai dengan ketentuan syariah dalam Islam. Kalkulator ini digunakan untuk menghitung jumlah uang yang harus dibayarkan sebagai zakat atas perak yang dimiliki.";
const KEYWORDS = "zakat perak, hitung zakat perak ";
const OG_URL = "https://do-calculate.com/calculator/id/silver-zakat/";
const apiEndpoint = `${SERVER_URL}/${Silver_Zakat_EndPoint}`;
function SilverZakatCalculator() {
  const [yearType, setYearType] = useState("");
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [silverWeight, setSilverWeight] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleSilverWeightChange = (event) => {
    setSilverWeight(event.target.value);
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateSilverZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ silverWeight, gramPriceSilver, yearType }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> Hitung Zakat Perak untuk Berbagai Kadar </h1>
          </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    Proses penghitungan zakat perak didasarkan pada serangkaian faktor penting, termasuk berat perak dan harga per gram. Jenis tahun yang digunakan dalam perhitungan, baik tahun Hijriah maupun Masehi, juga harus ditentukan.
                                </p>
                                <p>
                                    Batas nisab perak (nisab) ditetapkan sebesar 595 gram. Jika berat perak yang Anda miliki melebihi batas ini, zakat perak menjadi wajib. Nilai zakat dihitung berdasarkan persentase tertentu, di mana persentase zakat fitrah sebesar 2,5% digunakan menurut kalender Hijriah, atau persentase 2,577% menurut kalender Masehi, tergantung pada jenis tahun yang digunakan.
                                </p>
                                <p>
                                    Setelah menghitung nilai zakat perak, jumlah tersebut disesuaikan secara akurat untuk menentukan jumlah final yang wajib dikeluarkan. Kalkulator akan memberikan hasil akhir dalam bentuk laporan yang mencakup nilai zakat perak yang wajib dikeluarkan, status zakat (wajib atau tidak), batas nisab, dan jumlah uang yang dihasilkan.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Zakat Perak
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Jenis Tahun</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian" checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Masehi
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id="hijri" checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijriah
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="silverWeightNumber" className="form-label ms-2">Total Berat Perak </label>
                                    </b>
                                    <input
                                        type="number"
                                        id="silverWeightNumber"
                                        value={silverWeight}
                                        onChange={handleSilverWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">g</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="gramPriceGoldNumber" className="form-label ms-2">Harga gram perak (kadar 99.9)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceSilver}
                                        onChange={handleGramPriceSilverChange}
                                        className="form-control ml-2"
                                        style={{ width: '150px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateSilverZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Hitung'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Terjadi kesalahan :</u></b> Harap isi semua bidang dengan benar. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Hasil: </div></h4>
                                            <hr />
                                            <SilverZakatTable result={result}></SilverZakatTable>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Deskripsi Kalkulator Zakat Perak</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>Cara Menghitung Zakat Perak</h2>
                                <br />
                                <p>
                                    Kalkulator Zakat Perak didasarkan pada serangkaian variabel seperti berat perak dan harga per gram, serta jenis tahun (Hijriah atau Masehi). Nisab perak (batas nisab) ditetapkan sebesar 595 gram sesuai standar syariah.
                                </p>
                                <br />
                                <p>
                                    Jika berat perak melebihi batas nisab yang ditentukan, zakat perak menjadi wajib. Nilai zakat perak dihitung menggunakan persentase tertentu, yaitu 2,5% untuk zakat Hijriah dan 2,577% untuk zakat Masehi, tergantung pada jenis tahun.
                                </p>
                                <br />
                                <p>
                                    Setelah menghitung nilai zakat perak, jumlah tersebut disesuaikan dengan tepat untuk mendapatkan nilai final zakat dan jumlah uang yang wajib dikeluarkan.
                                </p>
                                <p>
                                    Kalkulator menyajikan hasil akhir dalam bentuk objek yang berisi jumlah zakat perak, status zakat (wajib atau tidak), nisab, dan jumlah uang final.
                                </p>
                                <br />
                                <p>
                                    Kalkulator ini berlaku untuk digunakan di semua negara Arab, termasuk:
                                </p>
                                <ul>
                                    <li>Kerajaan Arab Saudi</li>
                                    <li>Uni Emirat Arab</li>
                                    <li>Kuwait</li>
                                    <li>Bahrain</li>
                                    <li>Qatar</li>
                                    <li>Oman</li>
                                    <li>Yordania</li>
                                    <li>Mesir</li>
                                    <li>Irak</li>
                                    <li>Lebanon</li>
                                    <li>Suriah</li>
                                    <li>Palestina</li>
                                    <li>Yaman</li>
                                    <li>Maroko</li>
                                    <li>Aljazair</li>
                                    <li>Tunisia</li>
                                    <li>Libya</li>
                                </ul>
                                <br />
                                <hr />
                                <b>Sumber: </b>
                                <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/" rel="nofollow noreferrer" target="_blank">
                                    Islamic Relief Worldwide
                                </a>
                                <br />
                                <b>Tanggal revisi terakhir:</b> 28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div> <br />
        </div>
    );
}
export default SilverZakatCalculator;